import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';

import OldMan from '../images/old-man.jpeg'

const FragmentsPage = () => {
    return (
        <Layout>
            <SEO title="fragments" />
            <div style={{ height: '30px' }} />
            <h3>fragmented stories of my dad's childhood</h3>
            <p>
                我有时候没事干了，或者不想干正经事的时候，我就让我的爸爸给我讲他童年的故事。他在一九六几年的北京长大的。他讲的故事总是非常有意思，听起来非常好玩儿，虽然他的童年也不容易。我不想把这些故事忘掉，所以我就在这儿写下来。<br />
                <br />
                学校里的故事<br />
                1. 有一年，他的班来了一个新老师。老师第一次上黑板上写字的时候，下面就有一个学生看了一眼，大声的吼：“哇！这字儿写的太漂亮了！”<br />
                2. 每天下课以后，我爸就和他的朋友一起在校园里打篮球。有一天，两个学生打算一起顺着篮球框的杆儿爬上去。他们俩的重量太大了，所以这个篮球框就翻倒在地上了。这些人赶快把篮球框又立起来了，发现上面的环儿已经被撅得冲天了。<br />
                3. 有一天在校园刚下了雨，所以地上有很多水和泥。有一个学生找到了一个砖头，举起来往一个水坑里砸，溅的到处都是泥。我爸就赶快逃跑，要不然就会溅得一身泥。过了几秒钟一个老师就愤怒的跑出来了，抓住我的爸爸问他是谁干的。原来如此，刚刚溅起来的泥从一个开着的窗户飞到这个老师的桌子上了。<br />
                <br />
                骑自行车儿的故事<br />
                1. 我爸有时候就会听说附近有什么好玩儿的地方，比如说古代时候的桥。他周末有很多时间的时候，他就会把一个地图背下来，完了骑着他的自行车去找他听说的地方。<br />
                2. 这是我爸上大学以后的故事。有一次他和他的同学下课以后一起骑自行车往食堂赶，因为要不然食堂里好吃的饭很快就会被别人抢走。有一个人的袖子钩到另外一个人的车把上了，他们俩都摔倒了。大家就从他们旁边骑过去。有一个人哈哈大笑地说，“欲速则不达！！！”<br />
                3. 在北京骑自行车不容易，得跟行人和汽车一起走。他那天边用耳机听收音机边骑车。他前面的人看到了熟人儿，就急刹车。我爸也急刹车，就翻车了，往前翻了360°，一下儿就坐地上了。他没被伤着，而且他发现他的收音机还在口袋里，而且他的耳机还在耳朵里。<br />
                <br />
                做小玩意儿的故事，和别的乱七八糟的事情<br />
                1. 他对飞机很感兴趣，做了很多模型飞机和直升机。有很多时候他做完了就到外面玩儿他新做的飞机，完了就不小心的飞到房顶儿上。<br />
                2. 他对照相机也很有兴趣，可是买不起镜头。他非常喜欢去商店看各种各样的镜头。<br />
                3. 他把我奶奶的闹钟给拆了，链到收音机上了，使得这个闹钟闹的时候，收音机就会放音乐。我爸也往闹钟上抹了油。过了一段儿时间这个闹钟就不好使了。我奶奶非常生气。<br />
                4. 他的好朋友的父母非常严厉。他们俩想一起玩儿，可我爸不想跟他朋友的父母见面，所以我爸就做了一个小玩意儿（我忘了是什么）能从他朋友房子的外面使得他朋友家的收音机发出声音。这样我爸的朋友就会知道他来了，完了我爸就不需要见他的父母。<br />
                5. 我爸有时候不想和朋友一起出去玩儿，所以他就想了一个办法从里面把门从外面锁上。这样的话，他朋友来找他的时候，就会看到门是从外面锁上的，完了以为他不在家。<br />
                6. 我爷爷奶奶给我伯父买了一个字典。我爸也想要，所以他就催着爷爷奶奶给他也买一个。几月以前我爸把这个字典送给我了。里面有很多乱七八糟的画儿。他在边儿上也写了a到z这些字母—他说他在上课的时候找字找的最快。<br />
                7. 我爸非常喜欢干好玩儿的事儿。他有一次考数学的时候，故意考了很低的分数儿；老师很生气。另外，有一次他上课的时候就开始画画儿了，因为他没有课本儿。他画了他另外一节课的老师的脸。他这节课的老师看到了，非常生气。<br />
                {/* 8. 我爸特别会画老头的脸。我还以为他画的那个老头的脸是他自己的创造。可是我几月以前看一个中文电视剧，发现里面有一个跟他画的一模一样的老头的脸。我问他他是在哪儿学的怎么画老头的脸。他也说不出来，他说可能是从同学那儿学的。<br /> */}
                <br />
                我的中文水平不太高。你如果愿意对于我写的笔记提出任何关于语法或者词汇选择的建议，我会非常高兴的听！：）<br />
                <br />
            </p>
            {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <img src={OldMan} alt='stylized face of old man, drawn in chalk' style={{ width: 'auto', margin: 'auto' }} />
            </div> */}
        </Layout>
    );
};

export default FragmentsPage;
